import i18next from 'i18next';

export const t = (key: string) => i18next.t(key);
